import React, { type ReactNode } from 'react';
import { Providers } from '@/components/Auth/utils';
import { SignInProviders } from '@/components/Auth/SignIn/SignIn';

export const SignIn = ({
  isPopUp = false,
  callbackUrl,
  notice,
}: {
  isPopUp?: boolean;
  callbackUrl?: string;
  notice?: ReactNode;
}) => {
  const providers: Providers[] = [
    'github',
    'gitlab',
    'gitlab-self-hosted',
    'bitbucket',
  ];
  return (
    <SignInProviders
      providers={providers}
      isPopUp={isPopUp}
      callbackUrl={callbackUrl}
      notice={notice}
    />
  );
};
